export default __webpack_public_path__ + "3218d22017f103ff484778a9d7408d6f.svg";